const DEFAULT_ENDEAVOR_CONFIG = {
    apiKey: '81a42cb0-6b8f-4d93-9419-78d3660f2f8f',
    realm: 'dce.oneclub',
    baseUrl: 'https://oneclub.api.onvesper.com',
    heartbeatUrl: 'https://oneclub.api.onvesper.com/v1/heartbeat',
    videoBaseUrl: 'https://www.randa.tv/video'
};

const serverConfig = window.appState.endeavorConfig;

const endeavorConfig = Object.keys(DEFAULT_ENDEAVOR_CONFIG).reduce((config, key) => ({
    ...config,
    [key]: serverConfig && serverConfig[key] ? serverConfig[key] : DEFAULT_ENDEAVOR_CONFIG[key]
}), {});

export const REACT_APP_ENDEAVOR_X_API_KEY = endeavorConfig.apiKey;
export const REACT_APP_ENDEAVOR_REALM = endeavorConfig.realm;
export const REACT_APP_ENDEAVOR_BASE_URL = endeavorConfig.baseUrl;
export const REACT_APP_ENDEAVOR_HEARTBEAT_URL = endeavorConfig.heartbeatUrl;
export const REACT_APP_ENDEAVOR_VIDEO_BASE_URL = endeavorConfig.videoBaseUrl;

export const ENDEAVOR_AUTH = 'endeavor-auth';
export const GRANTED = 'GRANTED';
export const GRANTED_ON_SIGN_IN = 'GRANTED_ON_SIGN_IN';
export const DENIED = 'DENIED';

export const GRANT_TYPE = 'grant_type';
export const SUBJECT_TOKEN_TYPE = 'subject_token_type';
export const SUBJECT_TOKEN = 'subject_token';

export const TAGGED_VIDEOS_URL = `${REACT_APP_ENDEAVOR_BASE_URL}/api/v4/tagged/vod`;
